/* トップページ専用 */

document.addEventListener("DOMContentLoaded", () => {
  // section_solution タブ（Figma 22:380）
  const solutionSection = document.querySelector("#solution");
  if (solutionSection) {
    const tabs = solutionSection.querySelectorAll(".topSolution__tab");
    const panel = solutionSection.querySelector("#topSolution-panel");
    const human = solutionSection.querySelector(".topSolution__human");
    const partner = solutionSection.querySelector(".topSolution__partnerImg");
    const partnerLabel = solutionSection.querySelector(".topSolution__partnerLabel");
    const bubble1 = solutionSection.querySelector(".js-solution-bubble1");
    const bubble2 = solutionSection.querySelector(".js-solution-bubble2");
    const answer = solutionSection.querySelector(".js-solution-answer");
    const roleSub = solutionSection.querySelector(".js-solution-roleSub");
    const roleName = solutionSection.querySelector(".js-solution-roleName");
    const imgBase =
      human && human.getAttribute("src")
        ? human.getAttribute("src").replace(/[^/]+$/, "")
        : "";

    /** picture 内の img / source をまとめて差し替え（WebP source が残ると見た目が変わらない） */
    function setSolutionImg(el, filename) {
      if (!el || !imgBase || !filename) return;
      const pngUrl = imgBase + filename;
      el.setAttribute("src", pngUrl);
      const picture = el.closest("picture");
      if (!picture) return;
      const source = picture.querySelector('source[type="image/webp"]');
      if (!source) return;
      const webpUrl = pngUrl.replace(/\.(png|jpe?g)$/i, ".webp");
      source.setAttribute("srcset", webpUrl);
    }

    // デフォルト / 税金・お金 / 手続き・名義 / 不動産・空き家
    const DATA = {
      trouble: {
        human: "character_human_21.png",
        partner: "character_orange_10.png",
        bubble1: "遺産分割で揉めている",
        bubble2: "遺留分を請求したい",
        answer:
          "「パートナー弁護士をご紹介し、調停や法的な交渉代理を行います！」",
        roleSub: "提携",
        roleName: "弁護士",
        labelWide: false,
      },
      tax: {
        human: "character_human_22.png",
        partner: "character_pink_17.png",
        bubble1: "相続税がかかるか心配",
        bubble2: "準確定申告が必要",
        answer:
          "「相続財産の評価を行い、正確な納税と節税対策をサポートします！」",
        roleSub: "提携",
        roleName: "税理士",
        labelWide: false,
      },
      procedure: {
        human: "character_human_23.png",
        partner: "character_pink_14.png",
        bubble1: "不動産の名義を変えたい",
        bubble2: "銀行口座を解約したい",
        answer:
          "「戸籍収集から相続登記（名義変更）、預貯金の解約手続きを代行します！」",
        roleSub: "提携",
        roleName: "司法書士・行政書士",
        labelWide: true,
      },
      estate: {
        human: "character_human_24.png",
        partner: "character_orange_9.png",
        bubble1: "家を売って現金化したい",
        bubble2: "空き家の管理に困っている",
        answer:
          "「地域密着のネットワークで、査定・売却・買取・活用まで最適なプランをご提案します！」",
        roleSub: "当協会",
        roleName: "不動産窓口",
        labelWide: true,
      },
    };

    function apply(tabId) {
      const d = DATA[tabId];
      if (!d) return;
      setSolutionImg(human, d.human);
      setSolutionImg(partner, d.partner);
      if (bubble1) bubble1.textContent = d.bubble1;
      if (bubble2) bubble2.textContent = d.bubble2;
      if (answer) answer.textContent = d.answer;
      if (roleSub) roleSub.textContent = d.roleSub;
      if (roleName) roleName.textContent = d.roleName;
      if (partnerLabel) {
        partnerLabel.classList.toggle("is-wide", !!d.labelWide);
      }
      if (panel) {
        const active = Array.from(tabs).find((tab) => tab.dataset.tab === tabId);
        if (active && active.id) {
          panel.setAttribute("aria-labelledby", active.id);
        }
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabId = tab.dataset.tab;
        if (!tabId || !DATA[tabId]) return;
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        apply(tabId);
      });
    });

    const initial = Array.from(tabs).find((t) => t.classList.contains("is-active"));
    if (initial && initial.dataset.tab) {
      apply(initial.dataset.tab);
    }
  }

  // section_QA アコーディオン
  const qaSection = document.querySelector("#qa");
  if (qaSection) {
    const items = qaSection.querySelectorAll(".topQa__item");
    items.forEach((item) => {
      const btn = item.querySelector(".topQa__q");
      const panel = item.querySelector(".topQa__a");
      if (!btn || !panel) return;

      btn.addEventListener("click", () => {
        const willOpen = !item.classList.contains("is-open");
        items.forEach((other) => {
          const oBtn = other.querySelector(".topQa__q");
          const oPanel = other.querySelector(".topQa__a");
          const on = other === item && willOpen;
          other.classList.toggle("is-open", on);
          if (oBtn) oBtn.setAttribute("aria-expanded", on ? "true" : "false");
          if (oPanel) oPanel.hidden = !on;
        });
      });
    });
  }
});
